import { LatestSensorValuesStore } from "./latestSensorValues";
import { LatestThermostatValuesStore } from "./latestThermostatValues";
import { SensorConfigurationStore } from "./sensorConfiguration";
import { ThermostatConfigurationStore } from "./thermostatConfiguration";
import { ThermostatSettingsStore } from "./thermostatSettings";
import { UserPreferencesStore } from "./userPreferences";
export class RootStore {
    constructor(authStore, apolloClient) {
        this.authStore = authStore;
        this.latestSensorValuesStore = new LatestSensorValuesStore(this.authStore, apolloClient);
        this.latestThermostatValuesStore = new LatestThermostatValuesStore(this.authStore, apolloClient);
        this.sensorConfigurationStore = new SensorConfigurationStore(this.authStore, apolloClient);
        this.thermostatConfigurationStore = new ThermostatConfigurationStore(this.authStore, apolloClient);
        this.thermostatSettingsStore = new ThermostatSettingsStore(this.authStore, apolloClient);
        this.userPreferencesStore = new UserPreferencesStore(this.authStore, apolloClient);
    }
}
//# sourceMappingURL=RootStore.js.map